var loaded = false;
/**
 * Инициализирует интерфейс для взаимодействия с API Yandex ID.
 * После инициализации взаимодействие осуществляется через глобальный объект `window.S7yandex`.
 * */

export default (function (apiId) {
  if (loaded) {
    return;
  }

  loaded = true;
  var initInterval = setInterval(function () {
    if (window) {
      window.S7yandex = {
        apiId: apiId,
        domain: 'https://oauth.yandex.ru',
        path: {
          auth: 'authorize'
        }
      };
      clearInterval(initInterval);
    }
  }, 100);
});